import { Action, createReducer, on } from '@ngrx/store';
import { CurrencyModule } from '@src/app/models/currency/currency.module';
import { PointOfsaleModule } from '@src/app/models/point-ofsale/point-ofsale.module';

import * as settings from '../app-setting/app-setting.actions';


export const appSettingFeatureKey = 'appSetting';

export interface State {
  currency     : CurrencyModule,
  pos          : PointOfsaleModule,
  currentLang  : string 

}

export const initialState: State = {
currency: {
  ID: 4031,
  Currency_Code: "AED",
  Currency_Name: "UAE Dirham",
  Is_Base_Currency: false,
  Image_Url: "https://images.travelnow.global/Content/Currencies/AED.JPG",
  rate: 1
},
  pos          : undefined,
  currentLang  : 'en'
};


export const reducer = createReducer(
  initialState,
  on(settings.updateAppCurrency , (state , param) => ({...state , currency:param.Currency})),
  on(settings.updateAppPOS , (state , param) => ({...state , pos:param.POS})),
  on(settings.updateAppLang , (state , param) => ({...state , currentLang:param.Lang})),
  on(settings.setAirport , (state , param)=>({...state ,pos:{...state.pos,airport:param.data}})),
);

export function AppSettingReducer(
  state: State | undefined,
  action: Action) {
  return reducer(state, action);
}

